import React from "react";
import "./not-found-container.scss";

const NotFoundContainer = () => (
  <div className="not-found-container">
    404! This is not the page you are looking for!
  </div>
);

export default NotFoundContainer;
